import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import axios from 'axios';
import { AuthProvider } from './context/AuthContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';



// Interceptor global do axios para tratar 401 (sessão expirada)
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401 && localStorage.getItem('tipo')) {
      localStorage.clear();
      window.location = '/';
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// Ativa o service worker para PWA
serviceWorkerRegistration.register();
